<div style="font-size: large">Sind Sie sicher, dass Sie eine Kopie dieser Daten an <strong>{{data}}</strong>
  senden möchten?</div>
<br/>
<hr/>

<div style="float: right">
  <button mat-flat-button (click)="dialogRef.close({accepted: false})" style="margin-right: 16px">Nein</button>
  <button mat-flat-button color="primary" (click)="dialogRef.close({accepted: true})">Ja</button>
</div>
